// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"57":"index","594":"about","794":"statement"}[chunkId] || chunkId) + "." + {"57":"b13a5b7c","514":"cc37fa44","594":"a25aa888","794":"ddaa86e1"}[chunkId] + ".css";
};